module.exports = __webpack_public_path__ + "static/media/facebook-footer.00cbc531.svg";